// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.admin-textarea textarea {\n  padding-right: 40px;\n  resize: none;\n  border: none;\n  border-radius: 0px;\n  border-bottom: 1px solid #bfcbd9;\n}\n.moq-discount-form.form-block {\n  width: 95%;\n}", ""]);
// Exports
exports.locals = {
	"menuBg": "#101820",
	"menuText": "#8a97bb",
	"menuActiveText": "#e48f93",
	"menuActiveBg": "#934054"
};
module.exports = exports;
